/**
 *  财务设置
 * */
// MAX_WITHDRAW("MAX_WITHDRAW","骑士/经纪人单笔最高提现金额"),
// MIN_WITHDRAW("MIN_WITHDRAW","骑士/经纪人单笔最低提现金额"),
// WITHDRAW_COUNT("WITHDRAW_COUNT","每天每个帐号最多可支取次数"),
// USER_WITHDRAW_RATIO("USER_WITHDRAW_RATIO", "经纪人支取手续费"),
// RIDER_WITHDRAW_RATIO("RIDER_WITHDRAW_RATIO","骑士支取手续费"),
// USER_WITHDRAW_TEXT("USER_WITHDRAW_TEXT","经纪人支取文案"),
// RIDER_WITHDRAW_TEXT("RIDER_WITHDRAW_TEXT","骑士支取文案"),
// PLAT_NAME ("PLAT_NAME","平台单位名称")
import React, { PureComponent } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import {
    Form,
    Button,
    Space,
    InputNumber,
    Input,
    message,
} from 'antd';
import model from '@/reducers/system/financialset/model';
import { FloatConversion } from '@/util/conversion';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { XTitle } from '@/components/xqxc_ui';

const FormItem = Form.Item;
const { TextArea } = Input;

class Financial extends PureComponent {

    state = {
        isSubmit: false,//防止按钮重复点击
        formData: {},//表单数据
        key: null,
        floatConversion: new FloatConversion(),
        ratioNumber: 0,
    }

    componentDidMount() {
        this.props.getFinancial();//获取财务数据
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    componentDidUpdate(prevProps, prevStata) {
        if (this.props.financial !== prevProps.financial) {
            let { floatConversion } = prevStata;
            const {
                MAX_WITHDRAW,//骑士/经纪人单笔最高提现金额
                MIN_WITHDRAW,//骑士/经纪人单笔最低提现金额
                WITHDRAW_COUNT,//每天每个帐号最多可支取次数
                RIDER_WITHDRAW_RATIO,//骑士支取手续费
                USER_WITHDRAW_RATIO,//经纪人支取手续费
                TRANSPORT_WITHDRAW_RATIO,//小运力支取手续费
                RIDER_WITHDRAW_TEXT,//骑士支取文案
                USER_WITHDRAW_TEXT,//经纪人支取文案
                TRANSPORT_WITHDRAW_TEXT,//小运力支取文案
                BROKER_TAX_RATIO,//经纪人个税比例
                PLAT_NAME,//平台单位名称
            } = this.props.financial;

            let datas = {
                integralmax: floatConversion.divide(MAX_WITHDRAW, 100),
                integralmin: floatConversion.divide(MIN_WITHDRAW, 100),
                integralc: WITHDRAW_COUNT,
                drawchargeQ: floatConversion.divide(RIDER_WITHDRAW_RATIO, 100),
                drawchargeJ: floatConversion.divide(USER_WITHDRAW_RATIO, 100),
                drawchargeY: floatConversion.divide(TRANSPORT_WITHDRAW_RATIO, 100),
                brokerTaxRatio: BROKER_TAX_RATIO,
                remarkQ: RIDER_WITHDRAW_TEXT,
                remarkJ: USER_WITHDRAW_TEXT,
                remarkY: TRANSPORT_WITHDRAW_TEXT,
                companyName: PLAT_NAME
            };

            this.setState({
                key: Math.random(),
                formData: datas,
                ratioNumber: BROKER_TAX_RATIO,
            });
        }
    }

    onFinish = (values) => {
        let { integralmax, integralmin, integralc, drawchargeQ, drawchargeJ, drawchargeY, remarkQ, remarkJ, remarkY, brokerTaxRatio, companyName } = values;
        const { floatConversion } = this.state;
        let req = [
            { paramCode: 'MAX_WITHDRAW', paramValue: floatConversion.multiply(integralmax, 100) },
            { paramCode: 'MIN_WITHDRAW', paramValue: floatConversion.multiply(integralmin, 100) },
            { paramCode: 'WITHDRAW_COUNT', paramValue: integralc },
            { paramCode: 'BROKER_TAX_RATIO', paramValue: brokerTaxRatio },
            { paramCode: 'RIDER_WITHDRAW_RATIO', paramValue: floatConversion.multiply(drawchargeQ, 100) },
            { paramCode: 'USER_WITHDRAW_RATIO', paramValue: floatConversion.multiply(drawchargeJ, 100) },
            { paramCode: 'TRANSPORT_WITHDRAW_RATIO', paramValue: floatConversion.multiply(drawchargeY, 100) },
            { paramCode: 'RIDER_WITHDRAW_TEXT', paramValue: remarkQ },
            { paramCode: 'USER_WITHDRAW_TEXT', paramValue: remarkJ },
            { paramCode: 'PLAT_NAME', paramValue: companyName },
            { paramCode: 'TRANSPORT_WITHDRAW_TEXT', paramValue: remarkY },
        ];
        this.setState({ isSubmit: true }, () => {
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.SettlementParamService.settlementParamSetting', { req }, 'POST').then(() => {
                message.success('保存成功');
                this.setState({ isSubmit: false });
            }).catch((e = {}) => {
                message.error(e.message);
                this.setState({ isSubmit: false });
            });
        });
    };

    onReset = () => {
        this.formRef.resetFields();
    };

    render() {
        const { key, formData, ratioNumber } = this.state;

        return (
            <Form
                key={key}
                className={styles.tablehead}
                autoComplete='off'
                name="create"
                scrollToFirstError
                onFinish={this.onFinish}
                ref={(formRef) => this.formRef = formRef}
                initialValues={formData}

            >
                <div className={styles.homeLayout}>
                    <XTitle style={{ marginBottom: '20px', marginLeft: '20px' }} label='支取设置' />
                    <div className={styles.marg86}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <span className={styles.curt}>骑士/经纪人/小运力支取<i className={styles.ispan}>单笔最高</i></span>
                            <FormItem
                                name="integralmax"
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={1.00}
                                    max={9999.00}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curt}>元，单笔最低</span>
                            <FormItem
                                name="integralmin"
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={1.00}
                                    max={9999.00}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curt}>元</span>
                        </FormItem>
                        <FormItem className={`${styles.flexCurt}`} style={{ marginLeft: 162 }}>
                            <span className={styles.curt}>每天每个帐号最多可支取次数</span>
                            <FormItem
                                name="integralc"
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={1}
                                    max={9}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={0}
                                />
                            </FormItem>
                            <span className={styles.curt}>次</span>
                        </FormItem>

                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="drawchargeQ"
                                label='骑士支取手续费'
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    disabled
                                    style={{ width: '150px' }}
                                    min={0}
                                    max={100}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curt}>元/笔，银联收取（只用于APP结果显示）</span>
                        </FormItem>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="drawchargeJ"
                                label='经纪人支取手续费'
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={0}
                                    max={100}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curt}>元</span>
                        </FormItem>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="brokerTaxRatio"
                                label='经纪人个税比率'
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={0}
                                    max={60}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={0}
                                    onChange={value => this.setState({ ratioNumber: value })}
                                />
                            </FormItem>
                            <span className={styles.curt}>%（{ratioNumber} / 60）</span>
                        </FormItem>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="drawchargeY"
                                label='小运力支取手续费'
                                colon={false}
                                rules={[{ required: true, message: '请输入' }]}>
                                <InputNumber
                                    style={{ width: '150px' }}
                                    min={0}
                                    max={100}
                                    keyboard={true}
                                    placeholder='请输入'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curt}>元/笔  银联收取（只用于APP结果展示）</span>
                        </FormItem>
                        <FormItem
                            name="remarkQ"
                            colon={false}
                            label='骑士支取文案提示'
                            rules={[{ required: true, }]}
                        >
                            <TextArea
                                style={{ width: 470, position: 'relative' }}
                                showCount
                                maxLength={256}
                            />
                        </FormItem>
                        <FormItem
                            name="remarkJ"
                            colon={false}
                            label='经纪人支取文案提示'
                            rules={[{ required: true, }]}
                        >
                            <TextArea
                                style={{ width: 470, position: 'relative' }}
                                showCount
                                maxLength={256}
                            />
                        </FormItem>
                        <FormItem
                            name="remarkY"
                            colon={false}
                            label='小运力支取文案提示'
                            rules={[{ required: true, }]}
                        >
                            <TextArea
                                style={{ width: 470, position: 'relative' }}
                                showCount
                                maxLength={256}
                            />
                        </FormItem>
                        <XTitle style={{ marginBottom: '20px', marginLeft: '20px' }} label='财务信息' />
                        <FormItem
                            name="companyName"
                            colon={false}
                            label='平台单位名称'
                            rules={[
                                { required: true, message: '请输入平台单位名称' },
                                { max: 256, message: '平台单位名称最大长度为256' }
                            ]}
                        >
                            <Input placeholder='请输入平台单位名称' style={{ width: '470px' }} />
                        </FormItem>
                    </div>
                </div>
                <div className={styles.footerPoi}>
                    <Space size={'large'}>
                        <Button loading={this.state.isSubmit} type="primary" htmlType="submit">保存</Button>
                        <Button htmlType="button" onClick={this.onReset}>取消</Button>
                    </Space>
                </div>
            </Form >
        );
    }
}

Financial.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    financial: PropTypes.object,
    getFinancial: PropTypes.func,//获取财务数据(action)
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

const mapStateToProps = (state) => {
    return {
        financial: state.financialset.financial,
    };
};

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Financial);
